const HANDLED_STATUSES = [
  400, 401, 403, 404, 409, 422, 429, 500, 502, 503, 504,
];

const GENERIC_BACKEND_KEY = /^error_generic_\d+$/;
const I18N_KEY_SHAPE = /^[a-z][a-z0-9_]*$/;

const isSpecificKey = (value) =>
  typeof value === "string" &&
  I18N_KEY_SHAPE.test(value) &&
  !GENERIC_BACKEND_KEY.test(value);

export const normalizeApiError = (error) => {
  if (!error) return error;

  if (!error.response) {
    error.message = "network";
    return error;
  }

  const { status, data } = error.response;

  const localized = data?.error?.localized_error || data?.localized_error;
  if (isSpecificKey(localized)) {
    error.message = localized;
    return error;
  }

  const backendMessage = data?.error?.message || data?.message;
  if (isSpecificKey(backendMessage)) {
    error.message = backendMessage;
    return error;
  }

  if (HANDLED_STATUSES.includes(status)) {
    error.message = `http_${status}`;
    return error;
  }

  error.message = "unknown";
  return error;
};
